 $(function() {

    $('.change-language-to').on('click', function(e) {
      e.preventDefault();
      
      const id = $(e.currentTarget).data('lang');
      
      changeLanguage(id).then((response) => {

        languageChanged(response);
      
      });
    });

    function changeLanguage(id)
    {
      return new Promise((resolve, reject) => {
          
            (new Api).putRequest(`/language`, {id}).then((response) => {

                resolve(response);
            
            })
            
          });
      }

    function languageChanged(response)
    {
        Swal.fire({title:response.title,text:response.body}).then(() => {
        
        window.location.reload();
      
      });

    }
  });